import appSnackbarService from "@/services/appSnackbar.service";

export default {
  setSnackBarErrorFromErrorResponse: error => {
    if (
      error.response.data.i18n &&
      error.response.data.i18n === "USER_OR_PASSWORD_INCORRECT"
    ) {
      // don't show when it's login form error
      return;
    }
    if (error.response.data.hasOwnProperty("Message")) {
      appSnackbarService.error(error.response.data.Message);
    } else if (error.response.data.hasOwnProperty("error")) {
      appSnackbarService.error(error.response.data.error);
    } else {
      appSnackbarService.error("Unexpected error!");
    }
  }
};
